/**
 * A `/`-separated path as it goes into a URL, one segment at a time. A git ref name may hold `"`, `#`,
 * `%`, `<` or `&`, and a version site's directory is named after it; the static host decodes the URL
 * back to that name before it looks for the file.
 */
export const encodeUrlPath = (path: string): string => path.split("/").map(encodeURIComponent).join("/");
